import { useMemo } from 'react';
import { Row, Typography, Badge } from 'seagull';
import { AIEdit24 } from 'seagull/icons';
import { GetHelpMeWriteDrawerTID } from "./HelpMeWriteDrawer.utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const DrawerHeader = () => {
  const {
    HelpMeWriteDrawerTID
  } = useMemo(() => GetHelpMeWriteDrawerTID(), []);
  return /*#__PURE__*/_jsxs(Row, {
    gap: 8,
    alignItems: "center",
    testId: HelpMeWriteDrawerTID.Header(),
    children: [/*#__PURE__*/_jsxs(Row, {
      gap: 4,
      children: [/*#__PURE__*/_jsx(AIEdit24, {}), /*#__PURE__*/_jsx(Typography, {
        variant: "paragraph1",
        weight: "normal",
        children: "Help me write"
      })]
    }), /*#__PURE__*/_jsx(Badge, {
      skin: "primary",
      rounded: true,
      outlined: true,
      testId: HelpMeWriteDrawerTID.Badge(),
      children: "Beta"
    })]
  });
};
export default DrawerHeader;